import { HomeHero, TrustStrip } from "../components/home/HomeHero";
import { ProductChoice } from "../components/home/ProductChoice";
import { QuickStart } from "../components/home/QuickStart";
import { CompareBlock } from "../components/home/CompareBlock";
import { WhyMaas } from "../components/home/WhyMaas";
import { IsdeBlock } from "../components/home/IsdeBlock";
import { Inspiration } from "../components/home/Inspiration";
import { HomeReviews } from "../components/home/HomeReviews";
import { ServiceArea } from "../components/home/ServiceArea";
import { EndCTA, HomeFAQ } from "../components/home/HomeFAQ";
import { useSEO, buildServiceJsonLd } from "../lib/seo";
import { pageFaqJsonLd, useFaqs } from "../lib/faqs";
import { useSiteTexts } from "../lib/siteTexts";
import { SITE_URL } from "../lib/constants";
import { PAGE_TEXTS } from "../data/pageTexts";

const cfg = PAGE_TEXTS.home.blocks;

// Drie routes: prijsindicatie (primair, hero + QuickStart), offerte vergelijken en ISDE-check. Teksten via Beheer → Teksten → Homepage.
export default function Home() {
  const faqs = useFaqs("/");
  const t = useSiteTexts("home");
  const seo = t(cfg.seo);
  useSEO({
    title: seo.title,
    description: seo.body,
    path: "/",
    ogImage: `${SITE_URL}/images/v3/og-maas-kozijn.jpg`,
    jsonLd: buildServiceJsonLd(
      "Levering en montage van kunststof en aluminium kozijnen",
      "Complete nieuwe kunststof en aluminium kozijnen, schuifpuien en deuren inclusief glas en montage, voor woningen in Maassluis en Zuid-Holland."
    ),
    faqJsonLd: pageFaqJsonLd(faqs, "/"),
  });

  return (
    <div data-testid="home-page">
      <HomeHero block={t(cfg.hero)} />
      <TrustStrip />
      <ProductChoice />
      <QuickStart />
      <WhyMaas block={t(cfg.waarom)} />
      <CompareBlock block={t(cfg.offerte)} />
      <IsdeBlock block={t(cfg.isde)} />
      <Inspiration />
      <HomeReviews />
      <ServiceArea />
      <HomeFAQ faqs={faqs} />
      <EndCTA />
    </div>
  );
}
